module.exports = __webpack_public_path__ + "img/68.6da5ef5f.jpg";